import * as apiUtils from "../_api/apiUtils";

const baseUrl = "https://vpic.nhtsa.dot.gov/api/vehicles/decodevin/";

export const vinUSService = {
  getVINInfo,
};

function getVINInfo(VIN) {
  return apiUtils
    .get(`${baseUrl}${VIN}?format=json`)
    .then(apiUtils.handleResponse)
    .catch(apiUtils.handleError);
}
